<mat-card>{{'ordersPay' | translate}}</mat-card>


<div align="end" class="row" style="padding:10px;">
  <!-- <span class="spacer"></span> -->

  <button mat-raised-button color="primary" (click)="onRequestDone()" *ngIf="viewReq && PaymentReq.status == 1">
    <mat-icon>done</mat-icon>
    {{'requestDone' | translate}}
  </button>
  &nbsp;
  <button mat-raised-button color="warn" (click)="onReject()" *ngIf="viewReq && PaymentReq.status == 0">
    <mat-icon>backspace</mat-icon>
    {{'reject' | translate}}
  </button>
  &nbsp;
  <button mat-raised-button color="primary" (click)="accept()" *ngIf="viewReq && PaymentReq.status == 0">
    <mat-icon>done</mat-icon>
    {{'accept' | translate}}
  </button>

  <button mat-raised-button color="primary" (click)="refresh()" *ngIf="!viewReq">
    <mat-icon>autorenew</mat-icon>
    {{'refresh' | translate}}
  </button>

  &nbsp;
  <button mat-raised-button (click)="back()">
    <mat-icon>keyboard_backspace</mat-icon>
    {{'back' | translate}}
  </button>

</div>

<div class="container" style="padding: 25px;" *ngIf="!viewReq">

  <mat-grid-list cols="4" rowHeight="50px">
    <mat-grid-tile cols="2">
      <mat-form-field appearance="standard">
        <mat-label>{{'filter' | translate}}</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Mia" #input>
      </mat-form-field>
    </mat-grid-tile>
    <mat-grid-tile></mat-grid-tile>
    <mat-grid-tile></mat-grid-tile>
    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'status' | translate}}</mat-label>
        <mat-select [(value)]="selectedStatus" (selectionChange)="selectChange()">
          <mat-option *ngFor="let status of status" [value]="status.id">
            {{status.name | translate}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </mat-grid-tile>

  </mat-grid-list>

  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort>

      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'id' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.id}} </td>
      </ng-container>

      <ng-container matColumnDef="serviceClass">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'orderType' | translate}}</th>
        <td mat-cell *matCellDef="let row">
          <span *ngIf="row.serviceClass==1">
            <span [ngSwitch]="row.serviceNo">
              <p *ngSwitchCase="1">
                حسن سيرة وسلوك
              </p>
              <p *ngSwitchCase="2">
                عدم محكومية
              </p>
              <p *ngSwitchCase="3">
                رسوم المكرمة
              </p>
              <p *ngSwitchCase="4">
                رسوم مكرمة جيش
              </p>
              <p *ngSwitchCase="5">
                رسوم قبول موحد
              </p>
              <p *ngSwitchDefault>
                دفع رسوم جامعه
              </p>
            </span>
          </span>

          <span *ngIf="row.serviceClass==2">
            <span [ngSwitch]="row.serviceNo">
              <p *ngSwitchCase="1">
                فاتورة كهرباء
              </p>
              <p *ngSwitchCase="2">
                فاتورة مياه
              </p>
              <p *ngSwitchCase="3">
                فاتورة اتصالات
              </p>
              <p *ngSwitchDefault>
                مخالفة كمامة
              </p>
            </span>
          </span>

        </td>
      </ng-container>

      <ng-container matColumnDef="fullName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'fullName' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.users.fullName}} </td>
      </ng-container>

      <ng-container matColumnDef="createDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'dateTime' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.createDate | date: 'dd/MM/yyyy hh:mm a'}} </td>
      </ng-container>

      <ng-container matColumnDef="view">
        <th mat-header-cell *matHeaderCellDef> {{'view' | translate}} </th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button (click)="view(row)">
            <mat-icon>search</mat-icon>
          </button>
        </td>
      </ng-container>

      <!-- <ng-container matColumnDef="delete">
        <th mat-header-cell *matHeaderCellDef> {{'delete' | translate}} </th>
        <td mat-cell *matCellDef="let row">
            <button mat-icon-button (click)="onDelete(row.id)">
                <mat-icon>delete</mat-icon>
            </button>
          </td>
      </ng-container> 
   -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">{{'noDataMatchingTheFilter' | translate}} "{{input.value}}"</td>
      </tr>
    </table>

    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
  </div>

</div>

<app-matspinner dir="rtl" [overlay]="spinnerOverlay"></app-matspinner>

<ng-template #Modal>

  <h1 mat-dialog-title>{{'confirm' | translate}}</h1>
  <div mat-dialog-content>
    <p>{{'areYouSureToDelete' | translate}}</p>


  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">{{'cancel' | translate}}</button>
    <button mat-button cdkFocusInitial (click)="confirmDelete()">{{'yes' | translate}}</button>
  </div>

</ng-template>

<ng-template #ModalConfirmReject>

  <h1 mat-dialog-title>{{'confirm' | translate}}</h1>
  <div mat-dialog-content>
    <p>{{'areYouSureToReject' | translate}}</p>
    <mat-form-field appearance="standard">
      <mat-label>{{'rejectReason' | translate}}</mat-label>
      <textarea matInput [(ngModel)]="rejectReason"></textarea>
    </mat-form-field>
  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">{{'cancel' | translate}}</button>
    <button mat-button cdkFocusInitial (click)="confirmReject()">{{'yes' | translate}}</button>
  </div>

</ng-template>

<app-paymentrequestdetails *ngIf="viewReq" [orderDetails]="PaymentReq"></app-paymentrequestdetails>